import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=52de5b12&scoped=true&"
import script from "./TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TermsAndConditions.vue?vue&type=style&index=1&id=52de5b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de5b12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52de5b12')) {
      api.createRecord('52de5b12', component.options)
    } else {
      api.reload('52de5b12', component.options)
    }
    module.hot.accept("./TermsAndConditions.vue?vue&type=template&id=52de5b12&scoped=true&", function () {
      api.rerender('52de5b12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenants/TermsAndConditions.vue"
export default component.exports